// 按页面划分
export default {
  // 公共页面
  common: {
    title:"流量商城",
    pull_refresh: '下拉刷新',
    release_refresh: '松开刷新',
    refresh_loading: '刷新中...',
    footer_text: '服务由 Ucloudlink（NASDAQ: UCL）提供'
  },
  home: {
    input_placeholder: '搜索国家/地区',
    my_flow: '我的流量',
    charge_code: '充值卡',
    coupons:'优惠券',
    local_package: '本地流量',
    more: '更多',
    popular_destination: '国家/地区',
    buy_now: '购买',
    package_useing: '使用中',
    unused: '待使用',
    download_app: '下载APP',
    enter_the_mall_list: '进入商城列表',
    no_data: '暂无数据',
    no_data_available: '暂无可用套餐',
    copy_success: '复制成功',
    copy_fail: '复制失败',
    meritsTitle: '产品优势',
    merits1: '无需办卡、无月租',
    merits2: '内置top 2~3 运营商，自动切换网络',
    go_buy: '去购买',
    instant_savings: '立省',
    expires_in: '剩',
    download_app_tips: '下载APP获得更多优惠和体验'
  },
  packages: {
    sub_title: {
      us: '不含关岛、塞班岛',
      it: '适用梵蒂冈、圣马力诺',
      va: '适用意大利、圣马力诺',
      sm: '适用意大利、梵蒂冈',
      ma: '适用西撒哈拉',
      eh: '适用摩洛哥',
      ch: '适用列支敦士登',
      li: '适用瑞士',
      fr: '适用摩纳哥',
      mc: '适用法国',
      fi: '适用奥兰群岛',
      ax: '适用芬兰',
      gu: '适用塞班岛',
      mp: '适用关岛'
    },
    unlimited_packages: '畅享包',
    normal_packages: '普通包',
    multi_region_packages: '跨区域',
    regional_data: '区域流量',
    high_speed_text: '高速流量',
    infiniteFlow:'无限流量',
    unLimitData: '无限量',
    high_speed_text_year: '高速流量/月',
    package_list: '套餐列表',
    special_offer: '特惠',
    first_month: '首月',
    periodUnit: {
      day: '天',
      month: '月',
      hour: '小时',
      year: '年',
    },
    periodUnits: {
      day: '天',
      month: '个月',
      hour: '小时',
      year: '年',
    },
    periodUnitSimp: {
      day: '天',
      month: '月',
      hour: '小时',
      year: '年'
    },
    periodUnitMonthly: '每月',
    periodUnitsSimp: {
      day: '天',
      month: '个月',
      hour: '小时',
      year: '年'
    },
    unlimited_good_name: {
      day: '包天畅享',
      month: '月畅享',
      year: '年畅享'
    },
    continuousMonth : "连续包月",
    continuousDay : "连续包天",
    continuousYear:"连续包年",
    
    
    day_invalid: '当天失效',
    month_invalid: '当月失效',
    immediate_valid: '即时生效',
    tomorrow_day_valid: '次日生效',
    tomorrow_month_valid: '次月生效',


     

    // detail page
    detail: {
      cell_flow: '流量',
      cell_period: '有效期',
      buy_quantity: '购买份数',
      use_area: '适用区域',
      use_intro: '使用须知',
      buy_btn: '订购',
      pay: '支付',
      buy_tips: '您有%@packageName套餐正在使用，是否确定购买此套餐？',
      haveOrderTips: "您已生成待支付订单，点击确认前往我的流量页面查看！"
    },

    // confirm page
    confirm: {
      title: '支付订单',
      real_pay_amount: '实付金额',
      online_payment: '在线支付',
      create_order_error: '创建订单失败'
    }
  },
  pay: {
    // result page
    result: {
      loading_order_status: '正在努力获取订单状态...',
      buy_success: '订购成功',
      buy_pending: '支付待确认',
      buy_pending_tip: '支付结果确认中，如10分钟后还未到账，请咨询客服。',
      get_payment_info_fail: '支付信息获取失败',
      cell_package: '套餐包',
      cell_buy_amount: '支付金额',
      cell_real_amount: '实付金额',
      go_to_order_btn: '查看我的流量',
      back_home: '返回首页',
      back_mall: '返回商城',
      ordersn_empty: 'Order SN 为空',
      order_search_error: '没有查询到相关订单信息',
      goodsName:'商品名',
    },

    //fail page
    fail: {
      payment_fail: '支付失败',
      //payment_fail_desc: '请返回商品页面，重新购买',
      back_home: '返回首页'
    }
  },
  CountryGroup: {
    title: "国家/地区",
    placeholder: "搜索国家/地区",
    clear: "清除",
    history: "历史数据"
  },
  PromotionCode: {
    verification: {
      title: '充值卡',
      minititle:'充值码',
      input: '请输入充值码',
      explain: '说明：点击扫描图标和扫描充值卡的二维码，或者手动输入（注意字母大小写区别）',
      submit: '提交',
      exchange: '兑换',
      cancel: '取消',
      Inquiry: "确认要兑换",
      ErrorCode: '充值码错误',
    },
    recharge_success: {
      package: '流量包',
      content: '兑换成功',
      back: '返回商城',
      view_packets: '查看我的流量'
    }

  },
  order: {
    state: {
      inUse: '使用中',
      isFirst: '已优先',
      toFirst: '优先',
      inactive: '未激活'
    },
    periodUnits: {
      minute: '分钟',
      hour: '小时',
      day: '天',
      month: '个月',
    },
    useIntro: {
      tip1: '畅享包优先级高于普通包；',
      tip2: '相同类型流量包默认遵循先订购先使用的原则，但单地包优先于多地包；',
      tip3: '您也可手动调整同类型流量包使用优先级。'
    },
    myFlow: '我的流量',
    remainingFlow: '剩余流量',
    remainingTime: '剩余时间',
    remainingHighFlow: '剩余高速',
    validPeriod: '有效期',
    noneFlow: '暂无流量包',
    noneFlowTip: '购买流量包去享受优质网络吧',
    buyPackFlow: '购买套餐',
    checkInvalidFlow: '查看失效流量包',
    orderList: {
      title: '我的订单',
      amount_paid: '实付金额',
      device: '所属设备',
      order_details: '订单详情',
      total_amont: '总价',
      orderSN: '订单编号',
      createTime: '创建时间',
      cancelTime: '取消时间',
      payTime: '支付时间',
      unsubTime: '退订时间',
      payMethod: '支付方式',
      thirdSN: '交易流水号',
      delete: '删除',
      cancel: '取消订单',
      unsub: '退订',
      goto_cancel: '是否取消订单?',
      goto_unsubscribe: '是否退订订单?',
      delete_Tips: '删除后订单无法恢复，无法处理您的售后问题，确定是否删除？',
      status_success: '已完成',
      status_pending: '等待支付',
      status_cancel: '已取消',
      status_unsub: '已退订',
      payMethod_stripe: '信用卡'
    }
  },
  registerlogin: { 
    create_account_tip:'创建账户，开启您的专属体验',
    select_country_tip:'设备使用国家或地区',
    email_name: '邮箱',
    phone_name: '手机',
    email_address: '邮箱地址',
    password: '密码',
    country: '国家',
    select_country: '选择国家',
    cancel: '取消',
    confirm: '确定',
    please_enter: '请输入6-20个字符（字母、数字或符号的组合）',
    select_country_tips: '国家用于展示该国套餐，注册后不可修改，请确认！',
    global_roaming: '国际区号',
    phone_number: '手机号码',
    agree: '同意',
    user_agreement: '用户协议',
    and: '和',
    privacy_policy: '隐私政策',
    register_login: '注册或登录',
    login_error: "登陆次数过于频繁，请稍后重试！",
    register_error: "注册次数过于频繁，请稍后重试！",
    forgot_pwd: '忘记密码',
    app_tips: '此账号可通过下载app登陆，获得更多功能。',
    download_app:'去下载APP',
    rememberPwd:'记住密码',
    third_login: '其他登录方式',
    agreement_tips: "请勾选 用户协议 和 隐私政策 ",
    selectCountry_tips: '请注意，注册国家将直接影响您将来的支付方式和币种。请根据个人需求，谨慎选择。',
    login_error_cancel: "用户取消了登录",
    login_error_auth: "请允许浏览器弹出窗口",
    device_tips: "设备正在等待激活，感谢您的耐心等待，我们将在 24 小时内处理完毕。"
  },
  forgotPwd: {
    forgot_pwd: '忘记密码',
    email_address: '邮箱地址',
    next: '下一步',
    email_has_been_sent: '我们已发送一封电子邮件到 %@email。请点击其中的链接，并按步骤操作来找回您的密码。',
    have_retrieved_it: '我已找回',
    unable_to_receive_email: '收不到邮件？请检查您的垃圾邮件和已删除邮件目录下是否有来自 %@email 的邮件',
    or: '或',
    resend: '重新发送',
    global_roaming: '国际区号',
    phone_number: '手机号码',
    verification_code_has_been_sent: '我们已发送验证码至:',
    verification_code: '验证码',
    no_verification_code_received: '没有收到验证码?',
    please_enter: '请输入6-20个字符（字母、数字或符号的组合）',
    reset_password: '重置密码',
    reset_successful: '重置成功',
  },
  coupons: {
    coupons_name: '优惠券',
    no_coupons: '暂无优惠券',
    no_data: '暂无数据',
    applicable_to_the_following:'优惠券适用于以下流量'
  },
  digital:{
    title:"设备SN",
    purchased:"已购产品",
    viewAll:"查看全部",
    skinStore:"产品商店",
    completed:"已购买",
    goBuy:"购买",
    order: {
      title:"已购订单"
    },
    detail: {
      describe:"描述"
    }
  },
  viewPL: {
    other: '其他'
  },
  invalidFlow: {
    stateName: '状态',
    state: {
      NOT_ACTIVATED: "未激活",
      IN_USING: "可使用",
      USE_END: "已用完",
      EXPIRE: "已到期",
      TRANSFER: "已转移",
      UNSUBSCRIBE: "退订",
      VALID: "有效",
      INVALID: "无效",
      EXCHANGE_POINTS: "兑换积分"
    },
    noneFlow: '暂无失效流量包',
    pageName: '失效流量包'
  },
  flowDetail: {
    title: '流量详情',
    flow: '流量',
    validTime: '生效时间',
    invalidTime: '失效时间',
    coverage: '适用区域',
    useIntro: '使用须知',
    purchaseTime: '购买时间',
    subtotal: '支付金额',
    status: '状态',
    cancel: '取消',
    buyAgain: '再次购买',
    validity: '有效期',
    tip: '温馨提示',
    cancelTip: '是否退订流量?',
    dataLeft: '剩余'
  },
  netError: {
    try_again: '重试',
    net_error: '无网络',
    try_again_desc: '请检查网络设置后再试试'
  },
  loadFail: {
    try_again: '重试',
    load_fail: '加载失败',
    load_fail_desc: '数据加载失败，请重试',
    IMEI_Not_Exist: 'IMEI 不存在,请尝试从正确入口进入',
    Project_Not_Exist:'发生异常,请联系客服(01)',
    commonError:'发生异常,请联系客服',
  },
  settlement_Easy_and_convenient:"省心省力",
  settlement_Great_deal:"超值优惠",
  settlement_Safe_and_secure:"安全透明",
  settlement_Autopay_service_regulation:"自动续订服务条款",
  settlement_Read:"查看",
  settlement_No_coupon:"暂无优惠",
  settlement_Subtotal:"原价",
  settlement_Coupon:"优惠",
  settlement_TOTAL:"实付金额",
  settlement_promotion_tip:"该活动与优惠券不可同享",
  settlement_coupon_tip:"该优惠券与活动不可同享",
  member_myFlow_noList:"没有数据~",
  detail_se_content:"省心省力，可随时关闭",
  Enter_Promo_code:"优惠码",
  Enter_Promo_Coupon:"优惠券",
  settlement_Not_used_coupon:"个优惠券未使用",
  settlement_Available_coupon:"可用",
  settlement_Unavailable_coupon:"不可用",
  please_Enter_Promo_code:"请输入优惠码",
  please_Select_Coupon_use:　"请选择您想要使用的优惠券",
  Buy_Now:"立即购买",
  Dont_Use_Any:"不使用优惠",
  settlement_confirm:"确定",
  settlement_tips:"确定",
  flowDetail_unsubscribe: "退订",
  flowDetail_unsubscribed: "已退订",
  flowDetail_isCancelPackage: "是否退订该套餐?",
  flowDetail_confirmAgreementUnsubscribe : "关闭自动续订服务后，您就无法享受超低价格优惠了！真的要关闭吗？",
  flowDetail_cancel: "取消",
  flowDetail_cancelSuccess: "退订成功",
  packages_detail_promotion:"促销活动",
  orderTips:{
        "iDay" : "天",
        "iDays" : "天",
        "iMonth" : "月",
        "iMonths" : "个月",
        'First_charge_discount':"首购<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol, 后续 %@money/%@periodSymbol 自动续费，可随时关闭",
        'Monthly_discount':"每月劲省 %@saveMoney/%@period，可随时关闭",
        'Ordinary_monthly_package':"省心省力，可随时关闭",
        "AlreadyPurchased":'很抱歉，每位用户仅可同时享受一个自动续订优惠服务。请关闭“%@”自动续订且待其使用完后再开通其他自动续订服务。',
        "Contract_recommendation_First":'<label>开通连续包月,首购仅</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">可随时关闭'
        +'<a class="btn">开通 ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>开通连续包月,每月仅</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">可随时关闭'
        +'<a class="btn">开通 ></a></p>',
        "Contract_recommendation_General":"<label>开通连续包月</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">省心省力，可随时关闭'
        +'<a href="javascript:;" class="btn">开通 ></a></p>',
        'BanlanceDoubleCheck':'确定使用余额支付？',
    },
  feedback: {
    title: "意见反馈",
    placeholder: "请输入您想要去的国家或其他问题，我们将尽快满足您的需要！",
    submit: "提交",
    submit_success: "提交成功",
    other_opinions: '其他意见',
  },
  view_country_input: '请输入账号',
  select_package: {
    title: '选择套餐',
    allPackage: '全部套餐',
    type: '类别',
    flow: '流量',
    month_package: '月包',
    flow_package: '流量包',
    time: '时长',
    period: '周期',
    auto_debit: '自动扣费说明',
    auto_subscribe: '自动订阅',
    detail: '套餐详情',
    carrier: '支持的运营商',
    country: '覆盖的国家列表',
    notice: '购买须知',
  }
}